// Utility functions for handling onboarding redirects and preserving original paths

const ORIGINAL_PATH_KEY = 'onboarding_original_path';

/**
 * Store the original path that the user was trying to access before onboarding redirect
 */
export function storeOriginalPath(path: string): void {
  if (path && path !== '/onboarding') {
    sessionStorage.setItem(ORIGINAL_PATH_KEY, path);
  }
}

/**
 * Get the original path that was stored before onboarding redirect
 */
export function getOriginalPath(): string | null {
  return sessionStorage.getItem(ORIGINAL_PATH_KEY);
}

/**
 * Clear the stored original path
 */
export function clearOriginalPath(): void {
  sessionStorage.removeItem(ORIGINAL_PATH_KEY);
}

/**
 * Redirect to the original path or fallback to dashboard
 */
export function redirectToOriginalPath(fallbackPath: string = '/daily-overview'): void {
  const originalPath = getOriginalPath();
  if (originalPath && originalPath !== '/onboarding') {
    clearOriginalPath();
    window.location.href = originalPath;
  } else {
    window.location.href = fallbackPath;
  }
}

/**
 * Check if the current page is an onboarding page
 */
export function isOnboardingPage(path: string = window.location.pathname): boolean {
  return path === '/onboarding' || path.startsWith('/onboarding/');
}

/**
 * Enhanced onboarding redirect handler that preserves original path
 */
export function handleOnboardingRedirect(redirectUrl: string, originalPath?: string): void {
  // Store the original path if provided
  if (originalPath && !isOnboardingPage(originalPath)) {
    storeOriginalPath(originalPath);
  }

  // Redirect to onboarding
  window.location.href = redirectUrl;
}
